import { Routes, Route } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import Header from './components/Header'
import Footer from './components/Footer'
import RegisterScreen from './screens/RegisterScreen'
import LoginScreen from './screens/LoginScreen'
import UserListScreen from './screens/UserListScreen'
import UserEditScreen from './screens/UserEditScreen'
import Home from './screens/Home'
import Inventory from './screens/Inventory'
import InventoryAdd from './screens/InventoryAdd'
import InventoryUpdate from './screens/InventoryUpdate'
import Settings from './screens/Settings'
import './bootstrap.min.css'
import './App.css'
import ListItems from './screens/ListItems'
import ListManufacturers from './screens/ListManufacturers'
import Pointofsale from './screens/Pointofsale'
import InventoryReports from './screens/InventoryReports'
import LowInventory from './screens/LowInventory'
import Dashboard from './screens/Dashboard'
import AdminRegister from './screens/AdminRegister'
import RegisterOwner from './screens/RegisterOwner'
import ProfileScreen from './screens/ProfileScreen'
import ReturnsScreen from './screens/ReturnsScreen'

const App = () => {
  return (
    <main>
      <Container className='py-3'>
        <Header />
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/register/' element={<RegisterScreen />} />
          <Route path='/owner/' element={<RegisterOwner />} />
          <Route path='/login/' element={<LoginScreen />} />
          <Route path='/admin/userlist' element={<UserListScreen />} />
          <Route path='/admin/user/:id' element={<UserEditScreen />} />
          <Route path='/profile' element={<ProfileScreen />} />
          <Route path='/admin/user/register/*' element={<AdminRegister />} />
          <Route path='/inventory/*' element={<Inventory />} />
          <Route path='/page/:pageNumber/*' element={<Inventory />} />
          <Route path='/search/:keyword/*' element={<Inventory />} />
          <Route path='/inventory/add' element={<InventoryAdd />} />
          <Route path='/inventory/edit/:id' element={<InventoryUpdate />} />
          <Route path='/settings/*' element={<Settings />} />
          <Route path='/items/*' element={<ListItems />} />
          <Route path='/pageitem/:pageNumberitem/*' element={<ListItems />} />
          <Route path='/name/*' element={<ListManufacturers />} />
          <Route
            path='/pagename/:pageNumbername'
            element={<ListManufacturers />}
          />
          <Route path='/pos/*' element={<Pointofsale />} />
          <Route path='/pagepos/:pageNumberpos/*' element={<Pointofsale />} />
          <Route path='/searchpos/:keyword/*' element={<Pointofsale />} />
          <Route path='/returns/*' element={<ReturnsScreen />} />
          {/* <Route path='/returns/update/*' element={<ReturnsScreen />} /> */}
          <Route path='/reports/*' element={<InventoryReports />} />
          <Route path='/reports/lowinventory/*' element={<LowInventory />} />
          <Route path='/lowpage/:lowpageNumber/*' element={<LowInventory />} />
          <Route path='*' element={<h1>404 Not Found</h1>} />
        </Routes>
        <Footer />
      </Container>
    </main>
  )
}

export default App
